import React from 'react';
import xw from 'xwind';

import { Section, Container } from '@/components/layout';
import { MRB } from '@/types/MRB';
import { Header, SpecialistCard } from '../components';

const MedicalReviewBoardPage = ({ mrbs }: { mrbs: MRB[] }): JSX.Element => {
  return (
    <Section>
      <Container css={xw`mt-10 mb-24 md[mt-20 mb-48]`}>
        <Header />
        <h2 css={xw`text-center text-xl mb-8 md[text-3xl mb-16]`}>
          Meet our Medical Review Board experts
        </h2>
        {mrbs.map((item) => (
          <SpecialistCard key={item.name} {...item} />
        ))}
      </Container>
    </Section>
  );
};

export default MedicalReviewBoardPage;
